import {
  Box,
  Combobox,
  Text,
  useFilter,
  useListCollection,
} from "@chakra-ui/react";
import { useEffect } from "react";
import type { CatalogItem } from "../types";

export function OnboardingComboBox({
  label,
  items,
  value,
  onValueChange,
  error,
  placeholder = "Buscar...",
}: {
  label?: string;
  items: CatalogItem[];
  value?: string;
  onValueChange: (value: string) => void;
  error?: string;
  placeholder?: string;
}) {
  const { contains } = useFilter({ sensitivity: "base" });
  const { collection, filter, set } = useListCollection<CatalogItem>({
    initialItems: items,
    filter: contains,
  });

  useEffect(() => {
    set(items);
  }, [items, set]);

  return (
    <Box spaceY={1.5} data-onboarding-error={error ? "true" : undefined}>
      {label && (
        <Text fontSize="sm" fontWeight="medium" color="gray.700">
          {label}
        </Text>
      )}
      <Combobox.Root
        collection={collection}
        value={value ? [value] : []}
        onValueChange={(details) => onValueChange(details.value[0] ?? "")}
        onInputValueChange={(e) => filter(e.inputValue)}
        invalid={!!error}
        openOnClick
      >
        <Combobox.Control>
          <Combobox.Input
            placeholder={placeholder}
            _focus={{ ring: "2", ringColor: error ? "red.500" : "palomma.500", borderColor: error ? "red.400" : undefined }}
          />
          <Combobox.IndicatorGroup>
            <Combobox.ClearTrigger />
            <Combobox.Trigger />
          </Combobox.IndicatorGroup>
        </Combobox.Control>
        <Combobox.Positioner>
          <Combobox.Content>
            <Combobox.Empty>No se encontraron resultados</Combobox.Empty>
            {collection.items.map((item) => (
              <Combobox.Item key={item.value} item={item}>
                <Combobox.ItemText>{item.label}</Combobox.ItemText>
                <Combobox.ItemIndicator />
              </Combobox.Item>
            ))}
          </Combobox.Content>
        </Combobox.Positioner>
      </Combobox.Root>
      {error && <Text fontSize="xs" color="red.500">{error}</Text>}
    </Box>
  );
}
